import { Component } from '@angular/core';
import { UstawieniaAplikacjiMobilnejDto } from '@interfaces/administracja/systems/ustawienia-aplikacji-mobilnej.interface';
import { InformacjeOSystemieService } from '@services/api/administracja/systems/informacje-o-systemie.service';
import { UstawieniaAplikacjiMobilnychService } from '@services/api/administracja/systems/ustawienia-aplikacji-mobilnej.service';
import { SystemDataService } from '@services/system-data.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent {
  aplikacjeMobilne: UstawieniaAplikacjiMobilnejDto;

  constructor(
    readonly systemDataService: SystemDataService,
    private readonly informacjeOSystemieService: InformacjeOSystemieService,
    private readonly ustawieniaAplikacjiMobilnychService: UstawieniaAplikacjiMobilnychService,
  ) {
    this.ustawieniaAplikacjiMobilnychService.getUstawienia().subscribe((v) => (this.aplikacjeMobilne = v));
  }
}
